import React, { ReactElement } from 'react';
import { styled } from '@material-ui/core/styles';
import { Box, Grid, Typography } from '@material-ui/core';

import { AvatarOutlined } from 'components/AvatarOutlined/AvatarOutlined';

const ItemStyled = styled(Box)(() => ({
  marginTop: '20px',
  marginBottom: '20px',
  fontSize: '12px',
  display: 'flex',
  gap: '12px',
}));

const ItemTitleStyled = styled(Typography)(({ theme }) => ({
  fontWeight: theme.typography.fontWeightMedium,
  color: 'black',
  marginBottom: '8px',
}));

export interface GridCustomItemProps {
  title: string;
  value: string | ReactElement;
  icon: ReactElement;
}

export const GridCustomItem = ({ title, value, icon }: GridCustomItemProps): JSX.Element => (
  <Grid item xs={4}>
    <ItemStyled>
      <AvatarOutlined>{icon}</AvatarOutlined>

      <div>
        <ItemTitleStyled>{title}</ItemTitleStyled>
        {value}
      </div>
    </ItemStyled>
  </Grid>
);
